<div class="dropdown-wrapper">
    <ham-button
        #filterButtonWrapper
        class="status-filter-button"
        size="lg"
        [variant]="isFilterActive ? 'transparent' : 'white'"
        [outline]="true"
        rightIcon="assets/hamIcons/chevron-down.svg"
        (click)="openFlyout(filterButtonWrapper)"
    >
        <span class="filter-number" *ngIf="selectedTiers?.length && isFilterActive">
            {{ selectedTiers?.length }}
        </span>
        Tier
    </ham-button>
</div>

<span class="menu-flyout" hamFlyout *ngIf="openedFlyout" [position]="flyoutPosition" (closeFlyout)="closeFlyout()">
    <div class="flyout-content">
        <div
            *ngFor="let option of statusOptions"
            class="custom-checkbox status-option"
            (click)="toggleTierSelection(option.value)"
        >
            <input
                type="checkbox"
                [checked]="selectedTiers?.includes(option.value)"
                (change)="$event.stopPropagation()"
            />
            <label (click)="$event.stopPropagation(); toggleTierSelection(option.value)">{{ option.label }}</label>
        </div>
        <div class="filter-actions">
            <ham-button variant="teal" size="sm" (click)="applyFilter()">Apply</ham-button>
            <ham-button variant="white" size="sm" (click)="clearFilter()">Clear</ham-button>
        </div>
    </div>
</span>
